import { Checkbox, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useContext, useId } from "react";
import { ALLERGENS_PATH } from "../../../functions/src/admin/paths";
import { useDatabase, useList } from "../../api/firebaseHooks";
import { langContext } from "../../api/Lang";
import { useStrings } from "../../common-strings";
import { useUserProfileStrings } from "./userProfile-strings";
import { AllergensList } from "../../types";

export default function Allergies({ allergiesValue, onAllergiesValueChange }: AllergiesProps) {

    const profileStrings = useUserProfileStrings();
    const commonStrings = useStrings();
    const [lang] = useContext(langContext);
    const allergies = allergiesValue;
    const setAllergies = onAllergiesValueChange;
    const hasIntolerances = allergiesValue != null;

    const allergens = useDatabase(ALLERGENS_PATH);
    const allergensList = useList(allergens);

    const onHasAllergies = ({ target: { value } }) => {

        if (!!value) {
            if (!allergies) {
                const newAllergies: AllergensList = { 'celery': null };
                newAllergies.foodIntolerances = '';
                setAllergies(newAllergies);
            }
        } else {
            setAllergies(null);
        }
    }

    const onFoodIntolerances = (target: string) => {

        let newAllergies = allergies;
        if (!!target || target == '') {
            newAllergies.foodIntolerances = target;
        } else {
            newAllergies.foodIntolerances = null;
        }
        setAllergies(newAllergies);
    }

    const onAllergies = (target: string, checked: boolean) => {
        let newAllergies = allergies;

        if (checked)
            // snapshot.child(ALLERGIES_PATH).child(target).ref.set(checked);
            newAllergies[target] = checked;
        else {
            newAllergies.foodIntolerances = !allergies.foodIntolerances ? '' : allergies.foodIntolerances;
            newAllergies[target] = null;
            // snapshot.child(ALLERGIES_PATH).child(target).ref.remove();
        }
        setAllergies(newAllergies);
    }

    const allergiesHeadingId = useId();
    const intolerancesFieldId = useId();

    return <div className="student-person-edit-dialog__field student-person-edit-dialog__field--allergies">

        <div className="student-person-edit-dialog__allergies-heading">
            <div id={allergiesHeadingId} className="account-figma-field__label">{profileStrings.allergiesSectionHeading}</div>
        </div>

        <div className="student-person-edit-dialog__allergies-radios">
            <RadioGroup
                row
                value={hasIntolerances ? 'yes' : ''}
                onChange={onHasAllergies}
                aria-labelledby={allergiesHeadingId}
            >
                <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label={commonStrings.yes}
                />
                <FormControlLabel
                    value=""
                    control={<Radio color="primary" />}
                    label={commonStrings.no}
                />
            </RadioGroup>
        </div>

        {hasIntolerances && <>
            <div className='order-core allergens'>
                {allergensList.map(allergen =>
                    <div className="allergen-item" key={allergen.key}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={allergies[allergen.key] ?? false}
                                    value={allergen.key}
                                    onChange={e => onAllergies(e.target.value, e.target.checked)}
                                />
                            }
                            label={
                                <span className='labels' style={{ marginLeft: '6px' }}>
                                    {allergen.child(lang)?.val()}
                                </span>
                            }
                        />
                    </div>
                )}
            </div>
            <div className="student-person-edit-dialog__intolerances">
                <label htmlFor={intolerancesFieldId} className="account-figma-field__label student-person-edit-dialog__intolerances-label">
                    {profileStrings.intolerancesFreeTextLabel}
                </label>
                <div className='order-remarks-box' >
                    <textarea
                        id={intolerancesFieldId}
                        className="student-person-edit-dialog__intolerances-textarea"
                        placeholder={profileStrings.intolerancesFreeTextPlaceholder}
                        value={allergies?.foodIntolerances ?? ""}
                        onChange={e => onFoodIntolerances(e.target.value)}
                    />
                </div>
            </div>
        </>}
    </div>
}

type AllergiesProps = {
    allergiesValue: AllergensList | null
    onAllergiesValueChange: (value: AllergensList | null) => void
}
